<template>
    <div class="home">
        <vue-card>
            <vue-tab :value="tabValue" type="card" @on-click="handleTab">
                <TabPane name="all" label="全部用户"></TabPane>
                <TabPane name="normal" label="普通用户"></TabPane>
                <TabPane name="ban" label="禁止用户"></TabPane>
            </vue-tab>
            <div class="container">
                <div class="list-all">
                    <list-search ref="search" @selectSearch="handleSearch"></list-search>
                    <list-table ref="table"
                                :loading="listLoading"
                                :count="listCount"
                                :list-data="listData"
                                :page="searchData.page"
                                :page-size="searchData.pageSize"
                                @selectPage="handlePage"
                                @changeUserStatus="changeUserStatue"></list-table>
                </div>
            </div>
        </vue-card>
    </div>
</template>

<script>
    import VueTab from "@/components/routerTab/RouterTab.vue";
    import VueTable from "@/components/table/Table.vue";
    import VueCard from "@/components/card/Card.vue";
    import listSearch from "./business/ListSearch";
    import listTable from "./business/ListTable"
    import $api from "@/service/index"

    export default {
        components:{
            VueTab,
            VueTable,
            VueCard,
            listSearch,
            listTable,
        },
        data(){
            return {
                tabValue:'all', //当前激活面板的name
                searchData : {
                    type : '1',
                    keyword : '',
                    groupId : "0",
                    page : 1,
                    pageSize : 10,
                },
                listData : [],
                listCount : 0,
                listLoading: true,
            }
        },
        mounted(){
            this.initList();
        },
        watch : {
            '$route' (to, from) {
                this.initList();
            }
        },
        methods: {
            /**
             * 顶部标签切换标签
             * @param {string} tabName 标签名
             */
            handleTab(tabName){
                switch(tabName){
                    case "all":
                        this.searchData.type = "1";
                        break;
                    case "normal":
                        this.searchData.type = "2";
                        break;
                    case "ban":
                        this.searchData.type = "3";
                        break;
                    default:
                        this.searchData.type = "1";
                        break;
                }

                this.searchData.keyword = '';
                this.searchData.groupId = "0";
                this.searchData.page = 1;
                this.searchData.pageSize = 10;

                this.jumpRoute();
            },
            /**
             * 列表搜索
             * @param {object} search 搜索条件
             */
            handleSearch(search){
                this.searchData.keyword = search.keyword;
                this.searchData.groupId = search.companyGroupId;
                this.searchData.page = 1;

                this.jumpRoute();
            },
            /**
             * 调整每页条数
             * @param {oobject} pageData 分页相关数据
             */
            handlePage(pageData){
                this.searchData.page = pageData.page;
                this.searchData.pageSize = pageData.pageSize;

                this.jumpRoute();
            },
            /**
             * 变更用户状态
             * @param {object} data 待操作的数据
             */
            changeUserStatue(data){
                let _self = this;
                $api.setUserStatus(data).then((res)=>{
                    for(let i = 0; i <= _self.listData;i++){
                        if(_self.listData[i].id === data.uid){
                            _self.listData[i] = Object.assign(_self.listData[i],{
                                'islogin' : data.islogin
                            });
                            break;
                        }
                    }

                    _self.$refs.table.finishChangeUserStatus();
                    _self.initList();
                    // _self.jumpRoute();
                });
            },
            //获取列表页用户信息
            getUserList(){
                let _self = this;
                let searchOptions = {
                    "page_size" : this.searchData.pageSize,
                    'page' : this.searchData.page,
                    'type' : this.searchData.type,
                    'key_word' : this.searchData.keyword,
                    'company_group_id' : (!this.searchData.groupId || this.searchData.groupId === "0") ? "" : this.searchData.groupId,
                };
                _self.listLoading = true;
                $api.getGroupUserList(searchOptions).then(data=>{
                    _self.listLoading = false;
                    _self.listCount = parseInt(data.count);
                    _self.listData = data.list;
                });
            },
            //将搜索参数存入路由并push
            jumpRoute(){
                this.$refs.table.initShowPhoneNum();
                let _self = this;
                this.$router.push({
                    name : "company-member-list",
                    query : _self.searchData,
                });
            },
            //初始化页面所有
            initList(){
                //获取路由参数
                let _self = this;
                this.searchData = Object.assign(_self.searchData,_self.$route.query?_self.$route.query:{});
                this.$refs.search.setSearchData({
                    keyword: _self.searchData.keyword,
                    companyGroupId: _self.searchData.groupId,
                });
                this.$refs.table.setPageOptions(_self.searchData.page,_self.searchData.pageSize);
                if(this.searchData.type == "2"){
                    this.tabValue = "normal";
                }else if(this.searchData.type == "3"){
                    this.tabValue = "ban";
                }else{
                    this.tabValue = "all";
                }
                this.getUserList();
            }
        }

    }
</script>

<style scoped>
    @import "./list.less";
</style>


// WEBPACK FOOTER //
// src/pages/company/member/List.vue